import {
  Card,
  CardContent,
  Box,
  Typography,
  Button,
  FormControl,
  useMediaQuery,
  Fab,
  Grid,
  Pagination,
  Alert,
  AlertTitle,
} from "@mui/material";
import { useState, FormEvent, useEffect } from "react";
import CommonModal from "./HWSubmitModal";
import LayoutWithIcons from "./LayoutWithIcons";
import { useCharactersContext } from "../hooks/Context";

interface Question {
  updatedBy: string;
  question: string;
  mediaUrl: string;
  difficultyLevel: string;
  answerType: number;
  active: boolean;
  marks: number;
  updatedDate: string;
  subjectId: number;
  questionBankId: number;
  classId: number;
  createdDate: string;
  createdBy: string;
  optionsList: Option[];
  questionPaperId: number;
  uiType: number;
  remarks: string;
}

interface Option {
  questionBankId: number;
  updatedBy: string;
  createdDate: string;
  createdBy: string;
  active: boolean;
  optionId: number;
  updatedDate: string;
  correctAnswer: boolean;
  option: string;
}

interface Layout3Props {
  Questions: Question[];
  sectionName: string;
}

const Layout3: React.FC<Layout3Props> = ({
  Questions,
  sectionName, // setCurrentQuestionIndex,
}) => {
  // console.log("Layout 3 Questions: ", Questions);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const isMobile = useMediaQuery("(max-width: 600px)");
  const isTablet = useMediaQuery("(max-width:820px)");
  const currentQuestion = Questions[currentQuestionIndex];
  const options = currentQuestion?.optionsList ?? [];
  const correctOptions = options
    .filter((option) => option.correctAnswer)
    .map((option) => option.option);
  const sentences = currentQuestion.question.split("<br>");
  const [modalOpen, setModalOpen] = useState(false);
  const [isCorrectSubmission, setIsCorrectSubmission] = useState<
    boolean | null
  >(null);
  const [showAlert, setShowAlert] = useState(false);
  const handleAlertClose = () => setShowAlert(false);
  setTimeout(handleAlertClose, 3000);

  // const [selectedOptions, setSelectedOptions] = useState<string[]>([]);
  const [selectedOptions, setSelectedOptions] = useState<string[]>(() => {
    const storageKey = `selectedOptionsLayout3_${currentQuestion.questionPaperId}`;
    const savedOptions = localStorage.getItem(storageKey);
    return savedOptions ? JSON.parse(savedOptions) : [];
  });

  // const handleOptionChange = (option: string) => {
  //   if (correctOptions.length === 1) {
  //     // If there is only one correct option, deselect all other options
  //     setSelectedOptions([option]);
  //   } else {
  //     if (selectedOptions.includes(option)) {
  //       setSelectedOptions(selectedOptions.filter((item) => item !== option));
  //     } else {
  //       setSelectedOptions([...selectedOptions, option]);
  //     }
  //   }
  // };
  // const handleOptionChange = (option: string) => {
  //   if (correctOptions.length === 1) {
  //     // If there is only one correct option, deselect all other options
  //     setSelectedOptions([option]);
  //   } else {
  //     if (selectedOptions.includes(option)) {
  //       setSelectedOptions(selectedOptions.filter((item) => item !== option));
  //     } else {
  //       setSelectedOptions([...selectedOptions, option]);
  //     }
  //   }
  // };
  const handleOptionChange = (option: string) => {
    if (selectedOptions.includes(option)) {
      setSelectedOptions(selectedOptions.filter((item) => item !== option));
    } else {
      setSelectedOptions([...selectedOptions, option]);
    }
  };

  const {
    questionScores,
    setQuestionScores,
    isViewMode,
    examAnswers,
    setExamAnswers,
  } = useCharactersContext();
  const questionPaperId = currentQuestion.questionPaperId;

  const handleFormSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setShowAlert(true);
    // console.log("Selected options:", selectedOptions);
    const isCorrect = correctOptions.every((option) =>
      selectedOptions.includes(option)
    );
    // console.log("isCorrect ", isCorrect);

    setIsCorrectSubmission(isCorrect);
    if (isCorrect) {
      // playCorrectSound();
      const questionIndex = questionScores.findIndex(
        (item) => item.questionBankId === currentQuestion.questionBankId
      );

      if (questionIndex !== -1) {
        // Update the existing score
        const updatedScores = [...questionScores];
        updatedScores[questionIndex] = {
          questionBankId: currentQuestion.questionBankId,
          questionPaperId: currentQuestion.questionPaperId,
          score: currentQuestion.marks,
          layoutNumber: currentQuestion.uiType,
          sectionName: sectionName,
        };
        setQuestionScores(updatedScores);
      } else {
        // Add a new score for the question
        setQuestionScores((prevScores) => [
          ...prevScores,
          {
            questionBankId: currentQuestion.questionBankId,
            questionPaperId: currentQuestion.questionPaperId,
            score: currentQuestion.marks,
            layoutNumber: currentQuestion.uiType,
            sectionName: sectionName,
          },
        ]);
      }
    } else {
      // playInCorrectSound();
      setQuestionScores((prevScores) => [
        ...prevScores,
        {
          questionBankId: currentQuestion.questionBankId,
          questionPaperId: currentQuestion.questionPaperId,
          score: 0,
          layoutNumber: currentQuestion.uiType,
          sectionName: sectionName,
        },
      ]);
    }

    const updatedExamAnswer = {
      questionBankId: currentQuestion.questionBankId,
      acutalOptionValue: correctOptions.join(","),
      enteredOptionValue: selectedOptions.join(","),
    };

    // Reset selectedOptions for the next question
    //setSelectedOptions([]);

    // Check if there is already an answer for the current question
    const existingAnswerIndex = examAnswers.findIndex(
      (answer) => answer.questionBankId === currentQuestion.questionBankId
    );

    if (existingAnswerIndex !== -1) {
      // If an answer already exists, update the existing one
      setExamAnswers((prevAnswers) =>
        prevAnswers.map((answer, index) =>
          index === existingAnswerIndex ? { ...updatedExamAnswer } : answer
        )
      );
    } else {
      // If there is no existing answer, add the new answer
      setExamAnswers((prevAnswers) => [...prevAnswers, updatedExamAnswer]);
    }

    // console.log("updatedExamAnswer ", updatedExamAnswer);
    // console.log("examAnswers  ", examAnswers);
  };

  const handleNavigate = (direction: "previous" | "next") => {
    if (direction === "previous") {
      setCurrentQuestionIndex((prevIndex) => Math.max(prevIndex - 1, 0));
    } else if (direction === "next") {
      setCurrentQuestionIndex((prevIndex) =>
        Math.min(prevIndex + 1, Questions.length - 1)
      );
    }
  };

  const playCorrectSound = () => {
    const correctSound = new Audio(
      require("../assets/correct-choice-43861.mp3")
    );
    correctSound.play();
    handleOpen();
  };

  const playInCorrectSound = () => {
    const incorrectSound = new Audio(
      require("../assets/wronganswer-37702.mp3")
    );
    incorrectSound.play();
    handleOpen();
  };

  const handleOpen = () => setModalOpen(true);
  const handleClose = () => setModalOpen(false);

  const handleContinue = () => {
    setCurrentQuestionIndex((prevIndex) =>
      Math.min(prevIndex + 1, Questions.length - 1)
    );
    setModalOpen(false);
  };

  const handleRetry = () => {
    setSelectedOptions([]);
    setModalOpen(false);
  };

  useEffect(() => {
    const storageKey = `selectedOptionsLayout3_${currentQuestion.questionPaperId}`;
    localStorage.setItem(storageKey, JSON.stringify(selectedOptions));
  }, [selectedOptions]);

  const handlePaginationChange = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setCurrentQuestionIndex(value - 1);
  };

  useEffect(() => {
    if (isViewMode) {
      setSelectedOptions(correctOptions);
      // console.log("correctOptions:", correctOptions);
    }
  }, [currentQuestion]);

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "auto",
        marginTop: isViewMode
          ? "2%"
          : isMobile
          ? "3%"
          : isTablet || (isTablet && isViewMode)
          ? "15%"
          : "auto",
      }}
    >
      {/* <CommonModal
        open={modalOpen}
        isCorrectSubmission={isCorrectSubmission}
        handleContinue={handleContinue}
        handleRetry={handleRetry}
        handleClose={handleClose}
      /> */}
      {showAlert && (
        <Alert
          severity="success"
          variant="filled"
          sx={{
            position: "fixed",
            top: "30%",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 9999,
            padding: "0.5",
          }}
        >
          <AlertTitle sx={{ color: "white" }}>Answer submitted</AlertTitle>
        </Alert>
      )}

      <LayoutWithIcons onNavigate={handleNavigate}>
        {currentQuestion && (
          <Card
            variant="outlined"
            sx={{
              borderRadius: "12px",
              boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
              pointerEvents: isViewMode ? "none" : "auto",
            }}
          >
            <CardContent>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  paddingBottom: "0px",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: "700",
                    fontSize: isMobile ? "100%" : "110%",
                    marginBottom: "2vh",
                  }}
                >
                  {sentences[0]}
                </Typography>

                {currentQuestion.mediaUrl &&
                  currentQuestion.mediaUrl.trim() !== "" && (
                    <img
                      src={currentQuestion.mediaUrl}
                      alt="Question Media"
                      width="100"
                      height="100"
                    />
                  )}
                {sentences[1] && (
                  <Fab
                    variant="extended"
                    sx={{
                      fontWeight: 600,
                      fontSize: isMobile ? "0.95rem" : "1.1rem",
                      cursor: "default",
                      fontFamily: '"Nunito","Segoe UI", sans-serif',
                      backgroundColor: "#E12027 !important",
                      color: "white",
                      p: isMobile ? 1.5 : 2,
                      m: 1,
                      boxShadow: "none",
                      marginTop: "2vh",
                      whiteSpace: "normal",
                      height: "auto",
                      minHeight: "48px",
                      maxWidth: isMobile ? "90vw" : "700px",
                      wordBreak: "break-word",
                      textTransform: "none",
                    }}
                  >
                    {sentences[1]}
                  </Fab>
                )}
              </Box>

              <form onSubmit={handleFormSubmit}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    mt: 1,
                  }}
                >
                  <FormControl>
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "center",
                        flexWrap: "wrap",
                        gap: "8px",
                      }}
                    >
                      {options.map((option) => (
                        <Button
                          key={option.optionId}
                          onClick={() => handleOptionChange(option.option)}
                          variant={
                            selectedOptions.includes(option.option)
                              ? "contained"
                              : "outlined"
                          }
                          sx={{
                            m: 1,
                            backgroundColor: selectedOptions.includes(
                              option.option
                            )
                              ? "#E12027"
                              : undefined,
                            "&:hover": {
                              backgroundColor: selectedOptions.includes(
                                option.option
                              )
                                ? "#E12027"
                                : undefined,
                            },
                          }}
                        >
                          {option.option}
                        </Button>
                      ))}
                    </Box>
                  </FormControl>
                </Box>
                {!isViewMode && (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      mt: 2,
                    }}
                  >
                    <Button type="submit" variant="contained">
                      Submit
                    </Button>
                  </Box>
                )}
              </form>
            </CardContent>
          </Card>
        )}
        <Grid container lg={12} md={12} sm={12} xs={12} justifyContent="center">
          <Pagination
            count={Questions.length}
            shape="rounded"
            sx={{
              marginBottom: "1vh",
              paddingTop: "4%",
            }}
            page={currentQuestionIndex + 1}
            onChange={handlePaginationChange}
          />
        </Grid>
      </LayoutWithIcons>
    </div>
  );
};

export default Layout3;
